import scriptsMap from '../config/scriptsMap';
import typeOf from '../utilities/typeOf';


function startScriptTest (script) {
  script.testInterval = setInterval(() => {
    if ( script.test() ) {
      dismissInterval(script);
      if ( !script.initialized && typeof script.init === 'function' ) {
        return script.init(function () {
          script.initialized = true;
          runScriptCallbacks(script);
        });
      }
      script.initialized = true;
      runScriptCallbacks(script);
    }
  }, 100);
}


function dismissInterval(script) {
  clearInterval(script.testInterval);
  delete script.testInterval;
}


function runScriptCallbacks (script) {
  script.loaded = true;
  if ( typeOf(script.callbacks).is(Array) ) {
    for ( let callback of script.callbacks ) {
      callback();
    }
  }

}


export default {

  load ( scriptId, callback ) {

    if ( !(scriptId in scriptsMap) ) return console.warn('A given script id is not present from the scriptsMap config.')

    let script = scriptsMap[scriptId];

    if ( !typeOf(script.test).is(Function) ) return console.warn('The requested script requires a test function.');

    // Just run callback if script is loaded already
    if ( script.loaded && typeOf(callback).is(Function) ) {
      return callback();
    }

    // Enqueue callback to call when script has loaded
    script.callbacks = script.callbacks || [];
    if ( typeOf(callback).is(Function) ) {
      script.callbacks.push(callback);
    }

    if ( script.loading ) return;

    // Inject script
    script.loading = true;
    let scriptElement = document.createElement('script');
    scriptElement.src = script.url;
    script.type = 'text/javascript';
    scriptElement.onError = function () {
      console.warn(`Unable to load script: ${scriptId}`)
      dismissInterval(script);
    }
    App.$body.append(scriptElement);
    startScriptTest(script);
  }

}
